module.exports = __webpack_public_path__ + "img/voucher-outline-black.490efa44.svg";